const notice = {
    title: 'お知らせ',
    see_all: 'すべて見る',
    empty: '現在お知らせはありません。',
    not_found: 'お知らせが見つかりませんでした。',
    load_failed: '読み込みに失敗しました。時間をおいて再度お試しください。',
}

export default notice
